import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { MaterialDesignModule } from './material-design/material-design.module';
import { ApplicationNotificationService } from './application-notification.service';
import { AuthModule } from './auth/auth.module';
import { QueryService } from './query.service';
import { LimitToPipe } from './limit-to.pipe';
import { KeysPipe } from './keys.pipe';
import { MaterialsService } from './materials.service';
import { SearchProductsModule } from './search-products/search-products.module';
import { ConfirmComponent } from './confirm/confirm.component';
import { LoadingDialogComponent } from './loading-dialog/loading-dialog.component';
import { LoadingComponent } from './loading/loading.component';
import { SharedService } from './shared.service';
import { TitleComponent } from './title/title.component';
import { SafeHtmlPipe } from './safeSVG.pipe';
import { SearchMaterialsPipe } from './searchMaterials.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialDesignModule,
    AuthModule,
    SearchProductsModule,
  ],
  providers: [ApplicationNotificationService, QueryService, MaterialsService, SharedService],
  declarations: [HeaderComponent, MenuComponent, FooterComponent, LimitToPipe, KeysPipe, SafeHtmlPipe, ConfirmComponent, LoadingDialogComponent,
  LoadingComponent, SearchMaterialsPipe,
  TitleComponent],
  exports: [HeaderComponent, MenuComponent, FooterComponent, LimitToPipe, KeysPipe, SafeHtmlPipe, MaterialDesignModule, SearchProductsModule,
            ConfirmComponent, LoadingDialogComponent, LoadingComponent, TitleComponent, SearchMaterialsPipe],
  entryComponents: [ConfirmComponent, LoadingDialogComponent],
})
export class SharedModule { }



// WEBPACK FOOTER //
// /app/src/app/shared/shared.module.ts